import { makeStyles } from "@fluentui/react-components";
export const useCopyPlanModalStyles = makeStyles({
    root: {
        maxWidth: "590px"
    }
});
